import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getQuotes } from "../../actions/artist";
import { setCondition } from "../../actions/cache";
import Meta from "../../components/layout/Meta";
import ExhibitionsList from "../../components/lists/ExhibitionsList";
import { Button } from "../../components/util/Clickable";
import { getPureMessage, IntlText } from "../../components/util/Text";

class ShowsScreen extends PureComponent {
  state = {
    currents: null,
    upcomings: null,
    pasts: null,
    meta: {
      current_page: 0,
      last_page: null,
    },
    loading: false,
  };

  componentWillMount = () => {
    if (this.props.condition[window.location.href]) {
      this.setState(this.props.condition[window.location.href]);
    } else {
      this.load();
    }
  };

  componentDidUpdate = () => {
    if (this.state.currents != null && this.state.pasts != null) {
      this.props.actions.setCondition(this.state);
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    return this.state.loading != nextState.loading;
  };

  load = () => {
    this.props.actions
      .getQuotes(this.props.artist.id, {
        timing: "current",
      })
      .then(({ value }) => {
        this.setState({
          currents: value.data,
        });
        this.forceUpdate();
      });

    this.readMore(true);
  };

  readMore = (refresh = false) => {
    if (!refresh) {
      this.setState({ loading: true });
    }

    this.props.actions
      .getQuotes(this.props.artist.id, {
        timing: "past",
        page: this.state.meta.current_page + 1,
      })
      .then(({ value, action }) => {
        if (value.status < 300) {
          this.setState({
            pasts:
              this.state.pasts && !refresh
                ? this.state.pasts.concat(value.data)
                : value.data,
            meta: value.response.data.meta,
          });
          this.forceUpdate();
        }
      })
      .catch((error) => console.log(error));

    this.props.actions
      .getQuotes(this.props.artist.id, {
        timing: "upcoming",
      })
      .then(({ value }) => {
        if (value.status < 300) {
          this.setState({
            upcomings:
              this.state.upcomings && !refresh
                ? this.state.upcomings.concat(value.data)
                : value.data,
            loading: false,
          });
          this.forceUpdate();
        }
      })
      .catch((error) => console.log(error));
  };

  render = () => {
    return (
      <div>
        <Meta
          title={this.props.artist.name + getPureMessage("artists.shows.meta")}
          description={this.props.artist.biography}
          image={this.props.artist.thumnail_url}
        />
        <h1 className="uk-heading-mark uk-h2">
          <IntlText
            id="artists.shows.current"
            values={{ name: this.props.artist.name }}
          />
        </h1>
        <div className="uk-margin-medium">
          <div className="uk-margin-medium">
            <ExhibitionsList size={2} exhibitions={this.state.currents} />
          </div>
        </div>

        <div className="uk-margin-xlarge">
          <h2 className="uk-heading-mark">
            <IntlText
              id="artists.shows.upcoming"
              values={{ name: this.props.artist.name }}
            />
          </h2>
          <div className="uk-margin-medium">
            <ExhibitionsList size={3} exhibitions={this.state.upcomings} />
          </div>
        </div>

        <div className="uk-margin-xlarge">
          <h2 className="uk-heading-mark">
            <IntlText
              id="artists.shows.past"
              values={{ name: this.props.artist.name }}
            />
          </h2>
          <div className="uk-margin-medium">
            <ExhibitionsList size={3} exhibitions={this.state.pasts} />
          </div>
          {this.state.meta.last_page &&
            this.state.meta.last_page > this.state.meta.current_page && (
              <div className="uk-margin-medium uk-text-center">
                <Button
                  className="uk-button uk-button-default"
                  onClick={() => this.readMore(false)}
                  loading={this.state.loading ? 1 : 0}
                  ga={{
                    category: "button",
                    action: "artist_shows",
                    label: "more",
                  }}
                >
                  <IntlText id="forms.more" />
                </Button>
              </div>
            )}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
    condition: state.condition,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getQuotes: (...param) => dispatch(getQuotes(...param)),
      setCondition: (...param) => dispatch(setCondition(...param)),
    },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShowsScreen),
);
